import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import moment from 'moment';

const DateTimeCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem, field }) => {
  const value = field ? dataItem[field] : null;
  const parsedDate = value == null ? null : moment.parseZone(value);
  const formattedDateTime = parsedDate?.isValid() ? parsedDate.format('MM/DD/YYYY h:mm A') : '';

  return (
    <td style={{ textAlign: 'right' }}>
      <span>
        {formattedDateTime}
      </span>
    </td>
  );
};

export default DateTimeCell;
